import { createTheme } from '@mui/material/styles';
import * as components from './components';
import { palette } from '@/@mui/theme/palette';
import { shadows } from '@/@mui/tokens/shadows';
import { shape } from '@/@mui/tokens/shape';
import { typography } from '@/@mui/tokens/typography';

interface StatusColors {
  todo: string;
  progress: string;
  concluded: string;
}

declare module '@mui/material/styles' {
  interface PaletteColor {
    gradient?: string;
  }

  interface SimplePaletteColorOptions {
    gradient?: string;
  }

  interface TypographyVariants {
    fontWeightSemibold: number;
  }

  interface TypographyVariantsOptions {
    fontWeightSemibold?: number;
  }

  interface Palette {
    neutral: {
      0: string;
      100: string;
      200: string;
      300: string;
      500: string;
      600: string;
      700: string;
      900: string;
      lighter: string;
      light: string;
      main: string;
      dark: string;
      darker: string;
    };
    status: StatusColors;
  }

  interface PaletteOptions {
    neutral?: {
      0: string;
      100: string;
      300: string;
      500: string;
      700: string;
      900: string;
      lighter: string;
      light: string;
      main: string;
      dark: string;
      darker: string;
    };
    status?: StatusColors;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h5: false;
    h6: false;
    subtitle1: false;
    subtitle2: false;
    caption: false;
    overline: false;
    button: false;
  }
}

export const theme = createTheme({
  shape,
  palette,
  typography,
  shadows,
  components,
});
